<div class="px-px-24 py-px-16">
  <div class="d-flex justify-content-between align-items-center">

    <div class="me-4 inner-add-on left-add-on my-3" [formGroup]="form">
      <input type="search" class="form-control w-px-335" formControlName="keyword"
             placeholder="Rechercher un service d'affectation"/>
      <svg-icon class="inner-icon left" svgClass="placeholder-icon" src="/assets/icons/search-grey.svg"></svg-icon>
    </div>

    <app-button text="Ajouter un service d'affectation" srcIcon="assets/icons/plus.svg"
                (handleClick)="openAddServiceAffectationDialog()"
    ></app-button>
  </div>
  <app-data-table
    [dataSource]="affectationList"
    [columns]="customColumnsAffectation"
    [hasRowAction]="false"
    (nextPage)="pagination($event)"
    [totalItems]="totalItems"
    [pageSize]="limit"
    [isLoading]="loading"
  ></app-data-table>
</div>
